<template>
  <b-form id="reward-info" @submit.prevent="onSubmitForm">
    <b-row>
      <b-col cols="12">
        <b-card no-body class="mb-1 pb-4 container-card">
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6 mt-4">
                      <b-form-group
                        :label="'Name'"
                        label-for="reward-name"
                        label-class="font-medium-5 required"
                      >
                        <b-form-input
                          id="reward-name"
                          v-model="rewardInfoData.name"
                          required
                        />
                      </b-form-group>
                      <b-form-group
                        :label="'Value'"
                        label-for="reward-value"
                        label-class="font-medium-5 required"
                      >
                        <b-form-input
                          id="reward-value"
                          v-model="rewardInfoData.value"
                          @input="onNumberInput($event, 'value')"
                        />
                      </b-form-group>
                      <div class="mt-2">
                        <span class="font-medium-5">{{ "Status" }} </span>
                        <b-form-checkbox
                          v-model="rewardInfoData.status"
                          class="custom-control-success custom-toggle mt-1"
                          name="check-button"
                          switch
                        >
                          <span class="switch-icon-left toggle-text">{{
                            "Active"
                          }}</span>
                          <span class="switch-icon-right toggle-text">{{
                            "Inactive"
                          }}</span>
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
        <div class="privilege-btn-wrp mt-4 mb-2">
          <div class="d-flex justify-content-center">
            <cancel-button
              class="mr-2"
              @click.native="
                $router.push(`/lucky-winner/campaign/${campaignSeq}/round/${roundSeq}/reward/list`)
              "
            />
            <save-button type="submit" class="ml-1" />
          </div>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue"
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue"
import flatPickr from "vue-flatpickr-component"
import useRewardInfo from "./hooks/useRewardInfo"

export default {
  components: { CalendarPickerIcon, ClockPickerIcon, flatPickr },

  setup() {
    const {
      campaignSeq,
      roundSeq,
      rewardInfoData,
      validFrom,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onNumberInput,
      onSubmitForm,
    } = useRewardInfo()

    return {
      campaignSeq,
      roundSeq,
      rewardInfoData,
      CalendarPickerIcon,
      ClockPickerIcon,
      flatPickr,
      validFrom,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onNumberInput,
      onSubmitForm,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>
